import React, { useContext } from 'react';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import AnimatedElement from '../../../../../animations/components/AnimatedElement';
import AnimatedSelector from '../../../../../animations/components/AnimatedSelector';
import { getElementKey } from '../../../Carousel/services';
import { PaginationContext } from '../../contexts/pagination';
import './PaginationElements.css';
var defaultProps = {
  renderGroupItemContainer: function renderGroupItemContainer(item) {
    return /*#__PURE__*/React.createElement("div", {
      className: "group"
    }, item);
  }
};
export default function PaginationElements(_ref) {
  var children = _ref.children,
    renderGroupItemContainer = _ref.renderGroupItemContainer;
  var _useContext = useContext(PaginationContext),
    pagination = _useContext.pagination,
    animation = _useContext.animation;
  var getActivePageItems = pagination.getActivePageItems,
    activePage = pagination.activePage,
    getPreviousPage = pagination.getPreviousPage,
    getNextPage = pagination.getNextPage,
    totalPages = pagination.totalPages,
    getAllItems = pagination.getAllItems;
  var animated = animation.animated,
    status = animation.status,
    transition = animation.transition,
    duration = animation.duration,
    transitionProps = animation.transitionProps,
    _animation$targetSele = animation.targetSelector,
    targetSelector = _animation$targetSele === void 0 ? '' : _animation$targetSele;
  var activeElements = getActivePageItems() || [];
  var AnimatedComponent = _isEmpty(targetSelector) || _isNil(targetSelector) ? AnimatedElement : AnimatedSelector;
  function buildElement(element) {
    var finalElement = _isArray(element) ? renderGroupItemContainer(element) : element;
    if (animated) {
      return /*#__PURE__*/React.createElement(AnimatedComponent, {
        transitionType: transition,
        duration: duration,
        status: status,
        transitionProps: transitionProps,
        key: "animated-".concat(getElementKey(finalElement)),
        targetSelector: targetSelector
      }, finalElement);
    }
    return finalElement;
  }
  var elements = activeElements.map(function (element) {
    return buildElement(element);
  });
  return children(elements, {
    activePage: activePage,
    getPreviousPage: getPreviousPage,
    getNextPage: getNextPage,
    totalPages: totalPages,
    getAllItems: getAllItems
  });
}
PaginationElements.defaultProps = defaultProps;